// import { treatmentSlice } from "@app/routes/treatmentV2/store/treatmentSlice";
import { treatmentServerDataSlice } from "@app/routes/treatmentV3/store/treatmentServerDataSlice";
import { articulationSlice } from "@app/routes/treatmentV3/store/articulationSlice";
import { h5pGamesSlice } from "@app/routes/treatmentV3/store/h5pGamesSlice";
import { speechSlice } from "@app/routes/treatmentV3/store/speechSlice";
import { treatmentStudentSideSlice } from "@app/routes/treatmentV3/store/studentSlice";
import { studioSlice } from "@app/routes/treatmentV3/store/studioSlice";
import { videoSlice } from "@app/routes/treatmentV3/store/videoSlice";
import { websocketSlice } from "@app/routes/treatmentV3/store/websocketSlice";
import { treatmentContentSlice } from "@app/routes/treatmentV3/store/contentSlice";
import { administrationSlice } from "@app/routes/treatmentV3/store/administrationSlice";
import { studentGroupSlice } from "@app/routes/studentGroup/store/studentGroupSlice";
import { createSessionSlice } from "@app/common/calendar/components/createSession/V3/store/CreateSessionSlice";
import { youtubeSlice } from "@app/routes/treatmentV3/store/youtubeSlice";
import { readingSlice } from "@app/routes/activities/reading/store/readingSlice";
import { spellingSlice } from "@app/routes/activities/spelling/store/spellingSlice";
import { chatSlice } from "@app/routes/treatmentV3/store/chatSlice";
import { techStatusSlice } from "@app/routes/treatmentV3/store/techStatusSlice";
import { activityLibrarySlice } from "@app/routes/treatmentV3/store/activityLibrarySlice";

// import { relevantTreatmentBeforeActions, relevantTreatmentAfterActions } from "./treatmentV2Events";
import { relevantGroupsBeforeActions, relevantGroupsAfterActions } from "./studentGroupsEvents";
import { relevantSessionBeforeActions, relevantSessionAfterActions } from "./createSessionEvents";
import { relevantReadingBeforeActions, readingActionsRouterAfter } from "./readingEvents";
import { relevantSpellingBeforeActions, spellingActionsRouterAfter } from "./spellingEvents";
import { relevantTreatmentV3EventsBeforeActions, relevantTreatmentV3EventsAfterActions } from "./treatmentV3Events";
import { relevantLibraryBeforeActions, relevantLibraryAfterActions } from "./activityLibraryEvents";

const analyticsMW = () => store => next => action => {
  const stateBefore = store.getState();
  [treatmentServerDataSlice.name, administrationSlice.name, articulationSlice.name, treatmentContentSlice.name,
    h5pGamesSlice.name, speechSlice.name, treatmentStudentSideSlice.name, studioSlice.name,
    videoSlice.name, websocketSlice.name, youtubeSlice.name, chatSlice.name, techStatusSlice.name].some(word => action.type.startsWith(word))
    && relevantTreatmentV3EventsBeforeActions[action.type]?.(stateBefore, action);
  action.type.startsWith(studentGroupSlice.name) && relevantGroupsBeforeActions[action.type]?.(stateBefore, action);
  action.type.startsWith(createSessionSlice.name) && relevantSessionBeforeActions[action.type]?.(stateBefore, action);
  action.type.startsWith(activityLibrarySlice.name) && relevantLibraryBeforeActions[action.type]?.(stateBefore, action);
  action.type.startsWith(readingSlice.name) && relevantReadingBeforeActions[action.type]?.(stateBefore, action);
  action.type.startsWith(spellingSlice.name) && relevantSpellingBeforeActions[action.type]?.(stateBefore, action);

  const result = next(action);
  const stateAfter = store.getState();
  [treatmentServerDataSlice.name, administrationSlice.name, articulationSlice.name, treatmentContentSlice.name,
    h5pGamesSlice.name, speechSlice.name, treatmentStudentSideSlice.name, studioSlice.name,
    videoSlice.name, websocketSlice.name, youtubeSlice.name, chatSlice.name, techStatusSlice.name].some(word => action.type.startsWith(word))
    && relevantTreatmentV3EventsAfterActions[action.type]?.(stateBefore, stateAfter, action);
  action.type.startsWith(studentGroupSlice.name) && relevantGroupsAfterActions[action.type]?.(stateBefore, stateAfter, action);
  action.type.startsWith(createSessionSlice.name) && relevantSessionAfterActions[action.type]?.(stateBefore, stateAfter, action);
  action.type.startsWith(activityLibrarySlice.name) && relevantLibraryAfterActions[action.type]?.(stateBefore, stateAfter, action);
  action.type.startsWith(readingSlice.name) && readingActionsRouterAfter(stateBefore, stateAfter, action);
  action.type.startsWith(spellingSlice.name) && spellingActionsRouterAfter(stateBefore, stateAfter, action);

  return result;
};
  
export default analyticsMW();
